import React, { FC } from 'react';
import { Redirect, RouteComponentProps, Switch } from 'react-router-dom';
import PruRoute from '../../../../common/components/PruRoute';
import ParamsProvider from '../../../../common/components/ParamsProvider';
import AwardListingPage, { walletAwardFilterKeys } from './List/AwardListingPage';
import AwardDetailPage from './View/AwardDetailPage';

const WalletAwardRoutes: FC<RouteComponentProps> = ({ history, location, match }) => {
  return (
    <Switch>
      <Redirect exact from={match.path} to={`${match.path}/list`} />
      <PruRoute
        exact
        path={`${match.path}/list`}
        render={(props) => (
          <ParamsProvider {...props} acceptKeys={walletAwardFilterKeys}>
            <AwardListingPage />
          </ParamsProvider>
        )}
      />
      <PruRoute exact path={`${match.path}/create`} component={AwardDetailPage} />
      <PruRoute exact path={`${match.path}/edit/:id`} component={AwardDetailPage} />
      <PruRoute exact path={`${match.path}/view/:id`} component={AwardDetailPage} />
    </Switch>
  );
};

export default WalletAwardRoutes;
